/* Spedizione sempre gratuita.
   Nessuna chiamata alle tariffe reali di Shopify: mostriamo un breve
   caricamento e poi applichiamo la spedizione gratuita, che resta tale fino al
   pagamento. */
(function(){
  var box  = document.getElementById('cart-shipping-box');
  var wrap = document.getElementById('ship-rates');
  var list = document.getElementById('ship-rates-list');
  var note = document.getElementById('ship-rates-note');
  if(!box || !wrap || !list) return;

  var FREE = { handle:'free', title:'Spedizione gratuita', price:0 };
  var DELAY = 4000;           // durata del caricamento mostrato al cliente
  var timer = null;
  var applied = false;

  function apply(rate){
    window.WOW_SELECTED_RATE = rate ? { handle:rate.handle, title:rate.title, price:rate.price } : null;
    if(typeof window.WowCartSummary === 'function') window.WowCartSummary();
  }
  function setNote(msg){
    if(!note) return;
    note.hidden = !msg;
    note.textContent = msg || '';
  }
  function showLoading(){
    wrap.classList.add('is-loading');
    list.innerHTML = '<div class="sr-load"><i></i>Calcolo la spedizione per il tuo indirizzo…</div>';
    setNote('');
  }
  function showFree(){
    wrap.classList.remove('is-loading');
    list.innerHTML = '<label class="sr-opt sel">'
      + '<input type="radio" name="wow-ship-rate" value="0" checked>'
      + '<span class="sr-tt">' + FREE.title + '</span>'
      + '<b>Gratis</b></label>';
    setNote('Spedizione inclusa: nessun costo aggiuntivo al pagamento.');
    apply(FREE);
  }

  function run(){
    if(applied){ showFree(); return; }
    clearTimeout(timer);
    wrap.hidden = false;
    showLoading();
    timer = setTimeout(function(){ applied = true; showFree(); }, DELAY);
  }

  /* parte quando l'indirizzo è confermato */
  function sync(){
    if(box.getAttribute('data-state') === 'done') run();
    else { wrap.hidden = true; clearTimeout(timer); }
  }
  new MutationObserver(sync).observe(box, { attributes:true, attributeFilter:['data-state'] });
  document.addEventListener('wowcart:change', function(){ if(applied) apply(FREE); });
  sync();
})();
